// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"item_itemContainer__clIvO","image":"item_image__3cLyC","title":"item_title__2BT1J","description":"item_description__2A-A-","button":"item_button__2NcTW"};